module.exports = __webpack_public_path__ + "assets/images/slide3.jpg?_6aacc086b605";